import { Booking } from '../../services/booking.service'

export default {
    name: 'TimeslotContainer',

    components: {

    },
    mounted() {
        const container = this.$refs.scrollContainer

        const firstTimeslot = this.timeSlots[0]
        const lastTimeslot= this.timeSlots[this.timeSlots.length-1]

        let startDate = new Date()
        startDate.setHours(parseInt(firstTimeslot?.hours), 10)
        startDate.setMinutes(parseInt(firstTimeslot?.minutes), 10)

        let endDate = new Date()
        if (lastTimeslot.hours === "00" && lastTimeslot?.minutes === "00") {
            endDate.setHours(23)
            endDate.setMinutes(59)
        } else {
            endDate.setHours(parseInt(lastTimeslot?.hours), 10)
            endDate.setMinutes(parseInt(lastTimeslot?.minutes), 10)
        }

        const now = new Date()
        const differenceInHours = (date1, date2) => {
            // Calculate the difference in milliseconds
            const differenceMs = Math.abs(date2 - date1);
            // Convert milliseconds to hours
            return differenceMs / (1000 * 60 * 60);
        }

        const totalDiff = differenceInHours(startDate, endDate)
        const diffToNow = differenceInHours(startDate, now)

        const fraction = diffToNow/totalDiff
        container.scrollLeft = container.scrollWidth * fraction - 150
    },

    props: {
        hasEntityError: Boolean,
        timeSlots: Array,
        entities: Array,
        activeTimeSlots: Array,
        booking: new Booking()

    },

    methods: {

        isTimeSlotBooked(entityIndex, timeSlotIndex) {
            return this.$parent.isTimeSlotBooked(entityIndex, timeSlotIndex)
        },

        isTimeSlotActive(entityIndex, timeSlotIndex) {
           return this.$parent.isTimeSlotActive(entityIndex, timeSlotIndex)

        },

        selectTimeSlot(entityIndex, timeSlotIndex) {
            this.$parent.selectTimeSlot(entityIndex, timeSlotIndex)
        }


    }


}

